import { Button } from '@/components/ui/button';

const FollowerErrorState = ({ error, onRetry }) => {
  return (
    <div className='flex h-[50vh] items-center justify-center'>
      <div className='text-center'>
        <h3 className='text-lg font-semibold text-red-600'>
          Error loading followers
        </h3>
        <p className='text-sm text-muted-foreground'>{error}</p>
        <Button onClick={onRetry} className='mt-4' variant='outline'>
          Try Again
        </Button>
      </div>
    </div>
  );
};

export default FollowerErrorState;
